export const FIELD_LIMITS = {
  name: 100,
  company: 150,
  email: 254,
  url: 2048,
  message: 2000,
  phone: 10
};

export function digitsOnly(value, max = FIELD_LIMITS.phone) {
  return String(value ?? "").replace(/\D/g, "").slice(0, max);
}

export function requiredText(value, message) {
  return String(value ?? "").trim() ? "" : message;
}

export function isValidEmail(value) {
  const email = String(value ?? "").trim();
  if (!email || email.length > FIELD_LIMITS.email || /\s/.test(email)) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function emailError(value) {
  return isValidEmail(value) ? "" : "Please enter a valid email address.";
}

export function phoneError(value) {
  return digitsOnly(value).length === FIELD_LIMITS.phone
    ? ""
    : "Please enter a valid 10-digit phone number.";
}

export function selectError(value) {
  return String(value ?? "").trim() ? "" : "Please select an option.";
}

export function firstInvalidName(errors, order) {
  return order.find((name) => errors[name]) || "";
}
